import React, { PropsWithChildren } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import { gql } from '@yi/core';

import { black80, turquoise } from '~/styles';
import { isNotNull } from '~/types';

import { AccordionDetails, AccordionSummary, TabTitle, TeacherBio } from './elements';

interface Props {
  faq: (gql.typesSsr.Query_Course_yi_Course_sales_page_select_faq | null)[] | null;
}

export const FAQTab: React.FC<PropsWithChildren<Props>> = ({ faq }) => (
  <Box mt={2} mb={9}>
    {faq?.filter(isNotNull).map(({ question, answer }) => (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ width: 40, height: 40, color: turquoise }} />}
        >
          <TabTitle>{question}</TabTitle>
        </AccordionSummary>
        <AccordionDetails>
          <TeacherBio style={{ color: black80 }}>{answer}</TeacherBio>
        </AccordionDetails>
      </Accordion>
    ))}
  </Box>
);
